// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"420":"1537125d","571":"86cbc1e3"}[chunkId] + ".chunk.css";
};